const dialog = (
  state = {
    getCopyDialog: false
  },
  action
) => {
  switch (action.type) {
    case "TOGGLE_DIALOG":
      return {
        ...state,
        [action.name]: action.bool
      };
    default:
      return state;
  }
};
export default dialog;



// WEBPACK FOOTER //
// ./src/reducers/dialog.js